
import { BUSINESS_UNIT_EMAIL_CONTACT_METADATA } from './business-unit-email-contact.metadata';
import { BusinessUnitEmailContact } from './business-unit-email-contact.model';
import { BusinessUnitEntityDecorator } from './business-unit.decorator';
import { BusinessUnit } from './business-unit.model';
import { EntityDecorator, GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class BusinessUnitEmailContactEntityDecoratorBase extends GenericEntityDecorator<BusinessUnitEmailContact, number> {
  constructor() {
    super(BUSINESS_UNIT_EMAIL_CONTACT_METADATA, {
      get businessUnit(): EntityDecorator<BusinessUnit, string> {
        return new BusinessUnitEntityDecorator();
      }
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): number {
    if (params == null || params.businessUnitEmailContactId == null) {
      return null;
    }
    return parseInt(params.businessUnitEmailContactId);
  }
  toKeyUrlPathSegments(key: number): string {
    if (key == null) {
      return null;
    }
    return '' + key;
  }
  toKeyRouteSegments(item: BusinessUnitEmailContact): any[] {
    const key: number = this.metadata?.toKeyObject(item);
    if (key == null) {
      return null;
    }
    return [key];
  }
}




